export default __webpack_public_path__ + "static/media/dive_shot14.e6852e01.png";